import styled from 'styled-components';

const headerClsPrefix = `ui-table-header`;

export const tableHeaderClasses = {
  header: headerClsPrefix,
  headerTitle: `${headerClsPrefix}-title`,
  headerExtra: `${headerClsPrefix}-extra`,
} as const;

export const TableHeaderSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${({ theme }) => theme.spacings.text.XS}px;

  .${tableHeaderClasses.headerTitle} {
    ${({ theme }) => theme.mappedTypography.h5.default};
  }
`;
